import type { AppointmentPlanningExistingSourceRow } from "../../../../../../../../../../../_shared/_logic/appointments-contract"
import type {
  AppointmentPlanningCommitPayload,
  AppointmentPlanningPreviewPayload,
} from "../../../../../../../../../../../../../api/kehrblatt/planning"

export type InboxCommitItem = {
  action_case_id: string
  payload: Record<string, unknown>
}

export const buildCommitItems = ({
  sourceRows,
  payload,
}: {
  sourceRows: AppointmentPlanningExistingSourceRow[]
  payload: AppointmentPlanningCommitPayload
}): InboxCommitItem[] => {
  const sources = new Map(sourceRows.map((row) => [row.id, row]))

  return payload.rows.map((row) => {
    const source = sources.get(row.client_row_id)

    if (!source) throw new Error("Ausgewählte Inbox-Zeile fehlt.")

    return {
      action_case_id: source.id,
      payload: {
        work_order_id: row.work_order_id,
        requester_customer_id: source.requesterCustomerId ?? null,
        source_schedule_event_id: source.sourceScheduleEventId ?? null,
        canceled_schedule_event_id: source.canceledScheduleEventId ?? null,
        target: row.target,
        settings: {
          employee_ids: payload.employee_ids,
          appointment_contact_customer_id: row.appointment_contact_customer_id ?? null,
          start_date: payload.start_date ?? null,
        },
      },
    }
  })
}

export const planningPreviewPayload = (
  payload: AppointmentPlanningPreviewPayload,
  sourceRows: AppointmentPlanningExistingSourceRow[],
): Record<string, unknown> => {
  const sourceByActionCaseId = new Map(sourceRows.map((row) => [row.id, row]))
  const rowInputs = Object.fromEntries(
    payload.rows.flatMap((row): Array<readonly [string, Record<string, unknown>]> => {
      const source = sourceByActionCaseId.get(row.client_row_id)

      if (!source) return []

      return [
        [
          source.id,
          {
            work_order_id: source.workOrder.id,
            requester_customer_id: source.requesterCustomerId,
            source_schedule_event_id: source.sourceScheduleEventId,
            canceled_schedule_event_id: source.canceledScheduleEventId,
            expected_active_schedule_event_id:
              row.expected_active_schedule_event_id ??
              source.planningTargetScheduleEventId ??
              source.previousEvent?.id ??
              null,
            settings: {
              planning_strategy: row.planning_strategy ?? source.defaultPlanningStrategy ?? "AUTO",
              manual_appointment_type: row.manual_appointment_type ?? null,
              manual_appointment: row.manual_appointment ?? null,
              employee_ids: payload.employee_ids,
              forced_employee_id: row.forced_employee_id ?? row.appointment_employee_id ?? null,
              appointment_contact_customer_id:
                row.appointment_contact_customer_id ?? source.requesterCustomerId,
              flex_appointment_allowed: row.flex_appointment_allowed ?? null,
              start_date: payload.start_date ?? null,
              planning_horizon_days: payload.planning_horizon_days ?? null,
            },
          },
        ],
      ]
    }),
  )

  return {
    mode: "planning",
    row_inputs_by_action_case_id: rowInputs,
  }
}
